import { useState } from "react"
import { ApiFactory } from "../../core/config/ApiFactory";
import { useSnackbar } from "../../core/contexts/SnackbarContext";

interface ICriarEstabelecimentoPayload {
    tipoPessoa: string;
    cnpj?: string;
    cpf?: string;
    nomeFantasia?: string;
    nomeCompleto?: string;
    razaoSocial?: string;
    email: string;
    telefone: string;
    usuarioCriadorUuid: string;
    organizacaoUuid?: string;
    valorAssinatura?: number;
    endereco: {
        cep: string;
        rua: string;
        numero: string;
        complemento?: string;
        bairro: string;
        cidade: string;
        uf: string;
    };
    planoUuid: string;
}

export const useEstabelecimentos = () => {
    const [loading, setLoading] = useState(false);
    const snackbar = useSnackbar();
    const apiEstabelecimentos = ApiFactory.getApi("MS_ESTABELECIMENTOS");

    const buscarEstabelecimentosUsuario = async () => {
        setLoading(true);
        try {
            const { data } = await apiEstabelecimentos.get("/meus-estabelecimentos");
            return data;
        } catch (error) {
            snackbar("Ocorreu um erro ao buscar os seus estabelecimentos", { severity: "error" })
            return [];
        } finally {
            setLoading(false);
        }
    }

    const criarEstabelecimento = async (payload: ICriarEstabelecimentoPayload) => {
        setLoading(true);
        try {
            const { data } = await apiEstabelecimentos.post("/", payload);
            return data;
        } catch (error) {
            snackbar("Ocorreu um erro ao criar o estabelecimento", { severity: "error" });
            return null;
        } finally {
            setLoading(false);
        }
    }

    return {
        buscarEstabelecimentosUsuario,
        criarEstabelecimento,
        loading
    };
}
